export default __webpack_public_path__ + "static/media/logo.88f32150.svg";